import { render, staticRenderFns } from "./CustomCell.vue?vue&type=template&id=cf96f3ce&scoped=true&"
import script from "./CustomCell.vue?vue&type=script&lang=js&"
export * from "./CustomCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf96f3ce",
  null
  
)

export default component.exports